import { withBase } from '../config/api'

const COUNTRY_CODE_RE = /^[A-Z]{2}$/

const normalizeCountryCode = (value) => {
  const code = String(value || '').trim().toUpperCase()
  return COUNTRY_CODE_RE.test(code) ? code : null
}

const detectCountryFromLocale = () => {
  try {
    const locale =
      navigator.language ||
      navigator.userLanguage ||
      'sk-SK'

    const parts = locale.split('-')

    return normalizeCountryCode(parts[1]) || 'SK'
  } catch {
    return 'SK'
  }
}

export const detectUserCountry = async () => {
  try {
    const res = await fetch(withBase('/geo/country'), {
      credentials: 'include',
      cache: 'no-store'
    })

    const data = await res.json().catch(() => null)

    const country = normalizeCountryCode(
      typeof data === 'string'
        ? data
        : data?.country
    )

    if (res.ok && country) {
      return country
    }
  } catch {}

  return detectCountryFromLocale()
}